const tableSchemaBase = [
	{
		accessor: 'site',
		title: 'global.site',
	},
	{
		accessor: 'startDate',
		title: 'global.startDate',
	},
	{
		accessor: 'production',
		title: 'global.quantity',
	},
	{
		accessor: 'tokenEquivalent',
		title: 'global.tokenEquivalent',
	},
	{
		type: 'productionsStartMintWithoutRemoveActions',
		accessor: '',
		width: 80,
		resizable: true,
	},
];

export { tableSchemaBase };
